import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation } from "@tanstack/react-query";

export function useLeadReportCsv({ api, tz }: { api: ApiType; tz: string }) {
  return useMutation({
    mutationFn: async ({
      startDate,
      endDate,
      leadSourceList,
      presetLeadStatus,
    }: {
      startDate?: string;
      endDate?: string;
      leadSourceList?: number[];
      presetLeadStatus: string;
    }) => {
      const utcStart = zonedTimeToUtc(startDate as string, tz);
      const utcEnd = zonedTimeToUtc(endDate as string, tz);
      return await api.leadApi.reportCsv({
        dateFrom: utcStart,
        dateTo: utcEnd,
        leadSourceList,
        presetLeadStatus,
      });
    },
  });
}
